document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-article-content]").forEach((content) => {
    const minimum = Number(content.dataset.tocMinimum || 2);
    const layout = content.closest(".article-template__layout");
    const desktopToc = layout?.querySelector("[data-article-toc]");
    const mobileToc = layout?.querySelector("[data-article-toc-mobile]");
    const desktopList = desktopToc?.querySelector("[data-article-toc-list]");
    const mobileList = mobileToc?.querySelector("[data-article-toc-mobile-list]");

    if (!desktopList && !mobileList) return;

    const headings = Array.from(content.querySelectorAll("h2, h3")).filter((heading) =>
      heading.textContent.trim()
    );

    if (headings.length < minimum) {
      layout?.classList.add("article-template__layout--no-toc");
      return;
    }

    const usedIds = new Set(Array.from(document.querySelectorAll("[id]")).map((element) => element.id));
    const items = headings.map((heading) => {
      const text = heading.textContent.trim();
      const baseId = slugify(text) || "article-section";
      let id = heading.id || baseId;
      let count = 2;

      while (usedIds.has(id) && heading.id !== id) {
        id = `${baseId}-${count}`;
        count += 1;
      }

      heading.id = id;
      usedIds.add(id);
      heading.classList.add("article-container__anchored-heading");

      return {
        id,
        text,
        level: heading.tagName.toLowerCase(),
        heading,
      };
    });

    renderToc(desktopList, items);
    renderToc(mobileList, items);

    desktopToc?.removeAttribute("hidden");
    mobileToc?.removeAttribute("hidden");
    layout?.classList.add("article-template__layout--has-toc");

    initActiveHeading(items, layout);
  });
});

function slugify(text) {
  return text
    .toLowerCase()
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

function renderToc(list, items) {
  if (!list) return;

  list.innerHTML = items
    .map((item) => {
      const className = item.level === "h3" ? "article-toc__link article-toc__link--child" : "article-toc__link";
      return `<a class="${className}" href="#${item.id}" data-article-toc-link="${item.id}">${escapeHtml(item.text)}</a>`;
    })
    .join("");
}

function initActiveHeading(items, layout) {
  const links = Array.from(layout.querySelectorAll("[data-article-toc-link]"));
  if (!links.length) return;

  const setActive = (id) => {
    links.forEach((link) => {
      link.classList.toggle("is-active", link.dataset.articleTocLink === id);
    });
  };

  if (!("IntersectionObserver" in window)) {
    setActive(items[0].id);
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      const visible = entries
        .filter((entry) => entry.isIntersecting)
        .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);

      if (visible[0]) setActive(visible[0].target.id);
    },
    {
      rootMargin: "-20% 0px -65% 0px",
      threshold: [0, 1],
    }
  );

  items.forEach((item) => observer.observe(item.heading));
  setActive(items[0].id);
}

function escapeHtml(text) {
  const span = document.createElement("span");
  span.textContent = text;
  return span.innerHTML;
}
